<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <div class="post-search-page mb-4">
    <b-card v-if="post">
      <div class="d-flex full-width">
        <router-link :to="{ name: 'digital-replies' }">
          &laquo; Digital reply search
        </router-link>
        <div class="ui-spacer"></div>
        <router-link :to="{ name: 'post-view', params: { id: post.post_id } }">
          &laquo; View Original Post
        </router-link>
      </div>
    </b-card>

    <div class="row" v-if="!loading">
      <section class="col-12" v-if="post">

        <section class="details-overview">
          <h3 class="font-weight-bolder">Details</h3>

          <b-card>
            <div class="row">
              <p cy="status" class="col-3"><b class="d-block">
                Status</b> {{ post.status === 'AwaitingConfirmation' ? 'Needs Approval' : post.status  }}
              </p>
              <p v-if="post.status === 'Rejected'" cy="rejection-reason" class="col-3"><b class="d-block">
                Rejection Reason</b> {{ post.rejection_reason || 'Not specified' }}
              </p>
              <p cy="sender" class="col-3"><b class="d-block">Sender </b> {{ post.sender_name }} ({{ post.sent_by }}) </p>
              <p class="col-3">
                <b class="d-block">External Contact</b>
                {{ visitor.firstname }} {{ visitor.lastname }}
              </p>
              <p cy="reviewed_by" class="col-3">
                <b class="d-block">Reviewed By</b>
                {{getReviewedBy(post)}}
              </p>

              <div v-if="prison.purple_post_foreign_language_requires_approval && foreignLanguages && foreignLanguages.length > 0" class="col-3">
                <b class="d-block">Foreign Languages Detected</b>
                <span v-for="(lang, index) in foreignLanguages" :key="index">
                  {{ getCountryNameFromCode(lang.language_code) }}<span v-if="index < foreignLanguages.length - 1">, </span>
                </span>
              </div>

              <div v-if="analysis && keywordCount" class="col-3">
                <b class="d-block">Keyword Alerts Found</b>
                <p>
                  {{ keywordCount }} Keyword{{ keywordCount > 1 ? 's' : '' }} found
                </p>
              </div>

              <p cy="created" class="col-3"><b class="d-block">Created </b> {{ post.created_at | formatDateTime }} </p>
              <p cy="updated" class="col-3"><b class="d-block">Last Updated </b> {{ post.updated_at | formatDateTime }} </p>
            </div>
          </b-card>
        </section>

        <section class="d-flex flex-wrap mb-3">
          <h3 class="full-width font-weight-bolder">Postcard</h3>
          <post-card :back-only="true" class="mx-auto" :post="post" />
        </section>

        <section>
          <h3 class="font-weight-bolder">Post Contents</h3>
          <b-card>
            <p>
              {{post.message}}
            </p>
          </b-card>
        </section>

        <section v-if="post.status !== 'Pending'">
          <h3 class="font-weight-bolder">Post Analysis</h3>
          <post-analysis :is-reply="true" :post="post"/>
        </section>

        <section v-if="post.status === 'AwaitingConfirmation' && !print_queue_user">
          <h3 class="font-weight-bolder">Judge Reply</h3>

          <judge-digital-reply @refresh="$router.push({name: 'digital-replies'})" :post="post"></judge-digital-reply>
        </section>
      </section>
      <section v-else>
        <h4>No post found</h4>
      </section>
    </div>

    <section v-else>
      <b-spinner variant="primary" label="Loading post"></b-spinner>
    </section>
  </div>
</template>
<!-- eslint-enable -->

<script>
  import { mapState } from 'vuex';
  import VisitorUsersService from '@/services/VisitorUsersService';
  import DigitalRepliesService from '@/services/DigitalRepliesService'
  import JudgeDigitalReply from '@/views/digitalReplies/digitalReplyView/sections/JudgeDigitalReply.vue'
  import StringUtils from '@/util/StringUtils';
  import PostCard from '../../postView/sections/PostCard.vue';
  import PostAnalysis from '../../postView/sections/PostAnalysis.vue';
  import Countries from '../../../components/country/countryCodes.json';

  export default {
    name: 'DigitalReplyView',
    components: {
      PostCard,
      PostAnalysis,
      JudgeDigitalReply,
    },
    props: {
      id: {
        required: true,
        type: String,
      },
    },
    data() {
      return {
        loading: true,
        loadingVisitor: true,
        loadingPrison: true,
        loadingMonitor: true,
        post: {},
        visitor: null,
        mailMonitor: null,
      };
    },
    computed: {
      ...mapState({
        is_primary_user: state => !state.auth.user.is_clinician && !state.auth.user.is_print_queue_user,
        is_clinician: state => state.auth.user.is_clinician,
        print_queue_user: state => state.auth.user.is_print_queue_user,
        foreignLanguages: state => state.postCard.foreignLanguages,
        analysis: state => state.postCard.analysis,
        prison: state => state.auth.user.prison,
      }),
      keywordCount() {
        return this.analysis && Array.isArray(this.analysis.keyword_alerts)
          ? this.analysis.keyword_alerts.length
          : 0;
      },
    },
    mounted() {
      this.getPost();
    },
    methods: {
      getPost() {
        this.loading = true;
        DigitalRepliesService.getSingleReply(this.id).then(res => {
          this.post = res.data;
          this.$store.commit('postCard/SET_ACTIVE_MESSAGE', this.post.message);
          this.getVisitorDetails();
        }).catch(err => {
          console.log('could not get post', err);
          this.$toast.error('Could not get post, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        }).finally(() => {
          this.loading = false;
        });
      },
      getVisitorDetails() {
        this.loadingVisitor = true;
        VisitorUsersService.getUser(this.post.visitor_user_id).then(res => {
          this.visitor = res.data;
        }).catch(err => {
          console.log('could not get sender details', err);
          this.$toast.error('Could not get sender details, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        }).finally(() => {
          this.loadingVisitor = false;
        });
      },
      getReviewedBy(post) {
        if (post.status === 'Requested' || post.status === 'AwaitingConfirmation') {
          return '-'
        }
        if (post.reviewer && post.reviewer.name) {
          return StringUtils.toTitleCase(post.reviewer.name);
        }
        return 'System';
      },
      getCountryNameFromCode(code) {
        const country = Countries.find(item => item.code.toLowerCase() === code.toLowerCase());
        return country ? country.name : code;
      },
    },
  };
</script>
